'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTab = exports.toggleFilterDropdown = exports.toggleSlidingPanel = exports.toggleSideNavLinkGroup = exports.toggleSideNav = exports.toggleNavGroup = exports.createNavGroupKey = exports.closeModal = exports.openModal = exports.closeDropdown = exports.openDropdown = undefined;

var _handleActions;

var _ramda = require('ramda');

var _reduxActions = require('redux-actions');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultToEmpty = (0, _ramda.defaultTo)({});
var collapse = (0, _ramda.set)((0, _ramda.lensProp)('expanded'), false);

var OPEN_DROPDOWN = '@cjdev/visual-stack-redux/OPEN_DROPDOWN';
var CLOSE_DROPDOWN = '@cjdev/visual-stack-redux/CLOSE_DROPDOWN';

var openDropdown = exports.openDropdown = (0, _reduxActions.createAction)(OPEN_DROPDOWN, function (menuBarName, dropDownName) {
  return { menuBarName: menuBarName, dropDownName: dropDownName };
});
var closeDropdown = exports.closeDropdown = (0, _reduxActions.createAction)(CLOSE_DROPDOWN, function (menuBarName, dropDownName) {
  return { menuBarName: menuBarName, dropDownName: dropDownName };
});

var OPEN_MODAL = '@cjdev/visual-stack-redux/OPEN_MODAL';
var CLOSE_MODAL = '@cjdev/visual-stack-redux/CLOSE_MODAL';

var openModal = exports.openModal = (0, _reduxActions.createAction)(OPEN_MODAL, function (component, props) {
  return { component: component, props: props };
});
var closeModal = exports.closeModal = (0, _reduxActions.createAction)(CLOSE_MODAL);

var emptyModalState = { component: undefined, props: undefined };

var REGISTER_DROPDOWN = '@cjdev/visual-stack-redux/REGISTER_DROPDOWN';
var TOGGLE_DROPDOWN = '@cjdev/visual-stack-redux/TOGGLE_DROPDOWN';

var createNavGroupKey = exports.createNavGroupKey = (0, _reduxActions.createAction)(REGISTER_DROPDOWN);
var toggleNavGroup = exports.toggleNavGroup = (0, _reduxActions.createAction)(TOGGLE_DROPDOWN);

var TOGGLE_SIDENAV = '@cjdev/visual-stack-redux/TOGGLE_SIDENAV';
var toggleSideNav = exports.toggleSideNav = (0, _reduxActions.createAction)(TOGGLE_SIDENAV, function (collapsed) {
  return { collapsed: collapsed };
});

var TOGGLE_SIDENAV_LINKGROUP = '@cjdev/visual-stack-redux/TOGGLE_SIDENAV_LINKGROUP';
var toggleSideNavLinkGroup = exports.toggleSideNavLinkGroup = (0, _reduxActions.createAction)(TOGGLE_SIDENAV_LINKGROUP, function (expanded, linkGroupName) {
  return { expanded: expanded, linkGroupName: linkGroupName };
});

var TOGGLE_SLIDING_PANEL = '@cjdev/visual-stack-redux/TOGGLE_SLIDING_PANEL';
var toggleSlidingPanel = exports.toggleSlidingPanel = (0, _reduxActions.createAction)(TOGGLE_SLIDING_PANEL);

var TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN = '@cjdev/visual-stack-redux/TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN';
var toggleFilterDropdown = exports.toggleFilterDropdown = (0, _reduxActions.createAction)(TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN, function (filterLabel) {
  return { filterLabel: filterLabel };
});

var SELECT_TAB = '@cjdev/visual-stack-redux/SELECT_TAB';
var selectTab = exports.selectTab = (0, _reduxActions.createAction)(SELECT_TAB);

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, OPEN_DROPDOWN, function (state, _ref) {
  var _ref$payload = _ref.payload,
      menuBarName = _ref$payload.menuBarName,
      dropDownName = _ref$payload.dropDownName;
  return (0, _ramda.set)((0, _ramda.lensPath)(['menuBar', menuBarName, dropDownName, 'open']), true, state);
}), _defineProperty(_handleActions, CLOSE_DROPDOWN, function (state, _ref2) {
  var _ref2$payload = _ref2.payload,
      menuBarName = _ref2$payload.menuBarName,
      dropDownName = _ref2$payload.dropDownName;
  return (0, _ramda.set)((0, _ramda.lensPath)(['menuBar', menuBarName, dropDownName, 'open']), false, state);
}), _defineProperty(_handleActions, OPEN_MODAL, function (state, _ref3) {
  var payload = _ref3.payload;
  return (0, _ramda.set)((0, _ramda.lensProp)('modal'), payload, state);
}), _defineProperty(_handleActions, CLOSE_MODAL, function (state) {
  return (0, _ramda.set)((0, _ramda.lensProp)('modal'), emptyModalState, state);
}), _defineProperty(_handleActions, REGISTER_DROPDOWN, function (state, _ref4) {
  var payload = _ref4.payload;
  return (0, _ramda.over)((0, _ramda.lensProp)('navGroupDropdown'), (0, _ramda.assoc)(payload, false), state);
}), _defineProperty(_handleActions, TOGGLE_DROPDOWN, function (state, _ref5) {
  var payload = _ref5.payload;
  return (0, _ramda.over)((0, _ramda.lensPath)(['navGroupDropdown', payload]), _ramda.not, state);
}), _defineProperty(_handleActions, TOGGLE_SIDENAV, function (state, _ref6) {
  var collapsed = _ref6.payload.collapsed;
  return (0, _ramda.set)((0, _ramda.lensPath)(['sideNav', 'collapsed']), collapsed, state);
}), _defineProperty(_handleActions, TOGGLE_SIDENAV_LINKGROUP, function (state, _ref7) {
  var _ref7$payload = _ref7.payload,
      expanded = _ref7$payload.expanded,
      linkGroupName = _ref7$payload.linkGroupName;

  var linkGroups = defaultToEmpty((0, _ramda.view)((0, _ramda.lensPath)(['sideNav', 'linkGroups']), state));
  var stateWithResetLinkGroups = (0, _ramda.set)((0, _ramda.lensPath)(['sideNav', 'linkGroups']), (0, _ramda.map)(function (v) {
    return collapse(v);
  })(linkGroups), state);
  return (0, _ramda.set)((0, _ramda.lensPath)(['sideNav', 'linkGroups', linkGroupName, 'expanded']), expanded, stateWithResetLinkGroups);
}), _defineProperty(_handleActions, TOGGLE_SLIDING_PANEL, function (state) {
  return (0, _ramda.over)((0, _ramda.lensPath)(['slidingPanel', 'active']), _ramda.not, state);
}), _defineProperty(_handleActions, TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN, function (state, _ref8) {
  var filterLabel = _ref8.payload.filterLabel;
  return (0, _ramda.over)((0, _ramda.lensPath)(['slidingPanel', filterLabel, 'expanded']), _ramda.not, state);
}), _defineProperty(_handleActions, SELECT_TAB, function (state, _ref9) {
  var _ref9$payload = _ref9.payload,
      tabLayoutId = _ref9$payload.tabLayoutId,
      index = _ref9$payload.index;

  return (0, _ramda.set)((0, _ramda.lensPath)(['tabLayout', tabLayoutId, 'index']), index, state);
}), _handleActions), {
  menuBar: {},
  modal: emptyModalState,
  navGroupDropdown: {},
  sideNav: {},
  slidingPanel: {},
  tabLayout: {}
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack-redux/lib/actions.js
// module id = 101
// module chunks = 0